import authService from '@/services/auth/auth-service'

export const state = {
  user: {},
  loading: false
}

export const getters = {
  authUser: state => state.user,
  loggedIn: state => state.user.name !== undefined,
  superAdmin: state => state.user !== undefined && state.user.admin
}

export const actions = {
  async checkAuth({ commit }) {
    await authService
      .checkAuth()
      .then(response => {
        if (response) {
          commit('SET_USER', response.data)
        }
      })
      .catch(() => {
        // TODO - handle errors
      })
  },

  login({ commit }, payload) {
    commit('SET_LOADING', true)

    return new Promise((resolve, reject) => {
      authService
        .login(payload)
        .then(response => {
          commit('SET_USER', response.data)

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
        .then(() => {
          commit('SET_LOADING', false)
        })
    })
  },

  logout({ commit }) {
    commit('SET_LOADING', true)

    return new Promise((resolve, reject) => {
      authService
        .logout()
        .then(response => {
          commit('SET_USER', {})

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
        .then(() => {
          commit('SET_LOADING', false)
        })
    })
  }
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_USER(state, user) {
    state.user = user
  }
}
